import React from "react";
import {Table as TableReactStrap} from "reactstrap";

const Table = ({data: jsonData}) => {
    const {data} = jsonData;
    return (

        <TableReactStrap className="tablesorter" responsive>
            <tbody>
            {
                data.map((dat, key) =>
                    <tr key={key}>
                        <td className="text-center">{Object.keys(dat)[0]}</td>
                        <td className="text-center">{Object.values(dat)[0]}</td>
                    </tr>
                )
            }
            </tbody>
        </TableReactStrap>
    );
};

export default Table;